import type { TranslateService } from '@ngx-translate/core';

import type {
    ITrialFormV2ErrorMessages,
    ITrialFormV2GoogleButtonText,
} from 'components/molecules/trial-form-v2/entities/types';
import type { ITrialFormFullOptions } from 'components/molecules/trial-form-v2/entities/types';
import type { EnvironmentService } from 'src/services/environment/environment.service';
import { getTrialFormDefaultStrings } from 'src/shared/constants/strings/trial-form-strings';

/*
 *   What's going on here:
 *   1. Getting translations and list of error for Trial form
 *   2. Combine form options from front end
 *   3. Create object of default frontend params
 * */

export function trialFormDefaultOptionsFactory(
    translateService: TranslateService,
    environmentService: EnvironmentService
): ITrialFormFullOptions {
    const errorList = getTrialFormDefaultStrings().errorList;
    const transformedErrorList = Object.keys(errorList).reduce((acc, key) => {
        acc[key] = translateService.instant(errorList[key]);
        return acc;
    }, {}) as ITrialFormV2ErrorMessages;
    const inputLabelText = translateService.instant(getTrialFormDefaultStrings().inputLabelText);
    const inputPlaceholderText = getTrialFormDefaultStrings().inputPlaceholderText;
    const buttonSendText = translateService.instant(getTrialFormDefaultStrings().buttonSendText);
    const googleButtonText: ITrialFormV2GoogleButtonText = {
        business: translateService.instant(getTrialFormDefaultStrings().googleButtonText.business),
        nonBusiness: translateService.instant(getTrialFormDefaultStrings().googleButtonText.nonBusiness),
    };

    return {
        environment: environmentService.environment.origin,
        errorList: transformedErrorList,
        inputLabelText,
        inputPlaceholderText,
        buttonSendText,
        trialFormSendingData: {},
        emailValidation: {
            business: false,
            student: false,
        },
        hasGoogleAuth: false,
        hasAnimatedButton: false,
        googleButtonText,
    };
}
